import { IncidentReportType } from '@roadfootage/api-client'

// Centralized dictionary mapping incident types to common keywords.
// \b ensures we match whole words (e.g., 'hit' matches "hit" but not "white")
const patterns: Record<string, RegExp> = {
  [IncidentReportType.TrafficAccident]:
    /\b(crash|hit|smashed|rear-ended|t-boned|collision|accident|scraped|bumped|prang)\b/i,
  [IncidentReportType.BadDriving]:
    /\b(cut off|swerve|reckless|speeding|red light|stop sign|tailgating|close call|near miss|dangerous)\b/i,
  [IncidentReportType.RoadRage]:
    /\b(angry|yelling|finger|fight|brake check|aggressive|raging|swearing|abuse)\b/i,
  [IncidentReportType.LawEnforcement]:
    /\b(police|cop|pulled over|siren|lights|highway patrol|pursuit)\b/i
}

export function detectIncidentType(
  description: string | null | undefined
): IncidentReportType | null {
  if (!description) return null

  for (const [type, regex] of Object.entries(patterns)) {
    if (regex.test(description)) {
      return type as IncidentReportType
    }
  }

  return null
}
